module.exports = __webpack_public_path__ + "static/media/8.e85e4c5a.jpg";